import {
  GU_FAILURE,
  GU_PENDING,
  GU_SUCCESS,
  GSU_FAILURE,
  GSU_PENDING,
  GSU_SUCCESS,
  GSUE_FAILURE,
  GSUE_PENDING,
  GSUE_SUCCESS,
} from './constants'
import {getUsers as getUserApi} from '../../../services/user'

export async function getUser(dispatch, search) {
  try {
    dispatch({type: GU_PENDING})
    const response = await getUserApi(search)
    dispatch({type: GU_SUCCESS, payload: response})
  } catch (e) {
    console.log(`Get User Details Failed: ${e}`)
    dispatch({type: GU_FAILURE, payload: e})
  }
}

export async function getSearchUser(search, dispatch) {
  try {
    dispatch({type: GSU_PENDING})
    const response = await getUserApi(search)
    dispatch({type: GSU_SUCCESS, payload: response})
    return true
  } catch (e) {
    console.log(`Get User Details Failed: ${e}`)
    dispatch({type: GSU_FAILURE, payload: e})
    return true
  }
}

export async function getSearchUserEmail(search, dispatch) {
  try {
    dispatch({type: GSUE_PENDING})
    const response = await getUserApi(search)
    dispatch({type: GSUE_SUCCESS, payload: response})
    return true
  } catch (e) {
    console.log(`Get User Details Failed: ${e}`)
    dispatch({type: GSUE_FAILURE, payload: e})
    return true
  }
}

export async function updateSearchUser(users, dispatch) {
  try {
    let userArr = users.map(u => {
      return {
        id: u.user_id,
        first_name: u.user_name,
        last_name: '',
      }
    })
    dispatch({type: GSU_SUCCESS, payload: userArr})
    return true
  } catch (e) {
    console.log(`Get User Details Failed: ${e}`)
    dispatch({type: GSU_FAILURE, payload: e})
    return true
  }
}
